import * as React from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import finvolveLogo from "../icons/fvlogo.png";
import axios from "axios";
import { useNavigate } from "react-router";
import RevampBanner from "../components/RevampBanner";

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://finvolve.co/">
        FInvolve
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
      All Rights Reserved.
    </Typography>
  );
}


const defaultTheme = createTheme();

export default function InvestorLogin() {
  document.title = "Investor Login"
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  // console.log(API_BASE_URL)
  const [errors, setErrors] = React.useState("")
  const navigate = useNavigate()

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);

    const userCredentials = {email: formData.get("email")?.trim(), password: formData.get("password")?.trim()};

    try{
      const response = await axios.post(`${API_BASE_URL}/api/investor/login`, userCredentials);
      console.log(response)
      if(response.status===200){
        localStorage.setItem("finvolveInvestorData",JSON.stringify(response.data.data));
        navigate("/investor-dashboard");
      }
    }catch(error){
      setErrors("Invalid credentials!")
    }
  };

  const finvolveInvestorData = JSON.parse(localStorage.getItem("finvolveInvestorData"))

    React.useEffect(()=>{
    const finvolveInvestorData = JSON.parse(localStorage.getItem("finvolveInvestorData"))
        if(finvolveInvestorData?.email){
            navigate("/investor-dashboard")
            return
        }
    },[finvolveInvestorData?.email, navigate])

  return (
    <ThemeProvider theme={defaultTheme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <RevampBanner part="title" sx={{ mb: 3 }} />
          <img
            src={finvolveLogo}
            alt="IA Logo"
            style={{
              maxWidth: "270px",
              maxHeight: "180px",
              paddingRight: "0px",
              paddingBottom: "10px",
            }}
          />

          <Typography
            component="h2"
            variant="h5"
            marginTop={"12px"}
            marginBottom={"12px"}
          >
            Investor Login
          </Typography>

          {errors ? <Typography
            component="p"
            color={"red"}
            marginTop={"12px"}
            marginBottom={"12px"}
          >
            {errors}
          </Typography>:""}

          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ mt: 1 }}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
            />
            <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Remember me"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Sign In
            </Button>
            <Grid container textAlign={"center"}>
              <Grid item xs>
                <Link href="#" variant="body2">
                  Forgot password?
                </Link>
              </Grid>
              {/* <Grid item>
                <Link href="#" variant="body2">
                  {"Don't have an account? Sign Up"}
                </Link>
              </Grid> */}
            </Grid>
          </Box>
        </Box>
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
    </ThemeProvider>
  );
}
